import { createApp } from 'vue';
import App from '@/presentation/App.vue';
import pluginLoader from '@/presentation/libs/plugin-loader.lib';
import { clickOutside } from '@/presentation/directives/clickOutside.directive';
import { setupPwaInstallPrompt } from '@/presentation/composables';
import setupPwaUpdater from '@/presentation/helper/pwaUpdater';

import * as Sentry from '@sentry/vue';

setupPwaInstallPrompt();

if (import.meta.env.PROD) {
	setupPwaUpdater();
}

const app = createApp(App);

if (import.meta.env.PROD) {
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_CDN,
		sendDefaultPii: true,
		beforeSend(event) {
			if (event.request?.headers?.Authorization) {
				delete event.request.headers.Authorization;
			}

			if (event.extra?.response?.token) {
				delete event.extra.response.token;
			}

			return event;
		},
	});
}

app.use(pluginLoader);
app.directive('click-outside', clickOutside);
